import { useState, useMemo, useCallback } from "react";

import { textFormatter } from "../../../../../utils/formatter/formatter";

export const AdvancedFilterPanel = ({ actions, ctx, uiState }) => {

  const { setFilters, clearFilters, onClose } = actions;
  const { filterOptions, totalCount } = ctx;
  const { filters } = uiState;

  const [openGroups, setOpenGroups] = useState({});
  const toggle = key => setOpenGroups(p => ({ ...p, [key]: !p[key] }));

  const hierKeys = useMemo(() => Object.keys(filterOptions?.hierarquia ?? {}), [filterOptions]);
  const attrKeys = useMemo(() => Object.keys(filterOptions?.atributos ?? {}), [filterOptions]);

  const activeTags = Object.entries(filters).filter(([, v]) => v && (Array.isArray(v) ? v.length > 0 : true));

  const handleSelect = useCallback((key, val) => {
    setFilters(prev => {
      const current = Array.isArray(prev[key]) ? prev[key] : (prev[key] ? [prev[key]] : []);
      const updated = current.includes(val) ? current.filter(v => v !== val) : [...current, val];
      return { ...prev, [key]: updated.length > 0 ? updated : null };
    });
  }, [setFilters]);

  const renderGroup = (key, options) => {
    const selected = filters[key] || null;
    const open = !!openGroups[key];
    const hasSelected = Array.isArray(selected) ? selected.length > 0 : !!selected;

    return (
      <div key={key}>
        <button onClick={() => toggle(key)} style={{
          width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '11px 16px', background: 'none', border: 'none', cursor: 'pointer',
          fontSize: '12px', fontWeight: '600', color: hasSelected ? '#E8773A' : '#999', letterSpacing: '0.03em',
        }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            {hasSelected && (
              <span style={{
                width: 16, height: 16, borderRadius: '50%', backgroundColor: '#E8773A', color: '#fff',
                fontSize: '9px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {Array.isArray(selected) ? selected.length : 1}
              </span>
            )}
            {textFormatter(key, { textTransform: 'uppercase' })}
          </span>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="2.5" style={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s', flexShrink: 0 }}>
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </button>

        {open && (
          <div style={{ paddingBottom: 6 }}>
            {options.map(opt => {
              const isSelected = Array.isArray(selected) ? selected.includes(opt.label) : selected === opt.label;

              return (
                <button key={opt.label} onClick={() => handleSelect(key, opt.label)} style={{
                  width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  padding: '7px 16px 7px 24px', background: isSelected ? '#fff6f0' : 'none', border: 'none',
                  cursor: 'pointer', fontSize: '13px', color: isSelected ? '#E8773A' : '#333',
                  fontWeight: isSelected ? '600' : '400', textAlign: 'left',
                }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    {isSelected && <span style={{ width: 5, height: 5, borderRadius: '50%', backgroundColor: '#E8773A', display: 'inline-block', flexShrink: 0 }} />}
                    {opt.label}
                  </span>
                  <span style={{ color: '#bbb', fontSize: '12px', fontWeight: '500' }}>{opt.count}</span>
                </button>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.3)', zIndex: 999 }} />
      <div style={{
        position: 'fixed', top: 0, right: 0, bottom: 0, width: 320,
        backgroundColor: '#F7F7F7', boxShadow: '-4px 0 20px rgba(0,0,0,0.12)',
        zIndex: 1000, display: 'flex', flexDirection: 'column',
      }}>
        {/* Header */}
        <div style={{ padding: '16px 18px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 34, height: 34, borderRadius: '50%', backgroundColor: '#E8773A', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2">
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
              </svg>
            </div>
            <div>
              <div style={{ fontSize: '14px', fontWeight: '700', color: '#1a1a1a' }}>Filtros Avançados</div>
              <div style={{ fontSize: '11px', color: '#aaa' }}>Refine por hierarquia e atributos do produto</div>
            </div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: '20px', padding: '2px 4px', lineHeight: 1 }}>×</button>
        </div>

        {/* Corpo */}
        <div style={{ flex: 1, overflowY: 'auto', backgroundColor: '#F7F7F7', padding: '12px' }}>
          <div style={{ backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e8e8e8', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
            {/* Contagem + tags */}
            <div style={{ padding: '14px 16px' }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: activeTags.length > 0 ? 8 : 0 }}>
                <span style={{ fontSize: '18px', fontWeight: '700', color: '#1a1a1a' }}>{totalCount}</span>
                <span style={{ fontSize: '12px', color: '#aaa' }}>/ {totalCount} produtos</span>
                {activeTags.length > 0 && (
                  <button onClick={clearFilters} style={{ marginLeft: 'auto', fontSize: '11px', color: '#E8773A', background: 'none', border: 'none', cursor: 'pointer', fontWeight: '600' }}>
                    Limpar filtros
                  </button>
                )}
              </div>
              {activeTags.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {activeTags.map(([key, val]) => {
                    const vals = Array.isArray(val) ? val : [val];
                    return vals.map(v => (
                      <span key={`${key}-${v}`} style={{
                        display: 'inline-flex', alignItems: 'center', gap: 4,
                        padding: '2px 8px 2px 10px', borderRadius: '20px',
                        backgroundColor: '#fff6f0', border: '1px solid #f4c4a6',
                        fontSize: '11px', color: '#E8773A', fontWeight: '600',
                      }}>
                        {v}
                        <button onClick={() => handleSelect(key, v)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#E8773A', fontSize: '12px', lineHeight: 1, padding: 0 }}>×</button>
                      </span>
                    ));
                  })}
                </div>
              )}
            </div>

            {/* Seção HIERARQUIA */}
            <div style={{ padding: '10px 16px 4px', fontSize: '8px', fontWeight: '700', color: '#aaa', letterSpacing: '0.12em' }}>HIERARQUIA</div>
            {hierKeys.map((key, i) => (
              <div key={key} style={{ borderTop: i > 0 ? '1px solid #f5f5f5' : 'none' }}>
                {renderGroup(key, filterOptions.hierarquia[key])}
              </div>
            ))}

            {/* Seção ATRIBUTOS */}
            <div style={{ padding: '10px 16px 4px', fontSize: '8px', fontWeight: '700', color: '#aaa', letterSpacing: '0.12em' }}>ATRIBUTOS</div>
            {attrKeys.map((key, i) => (
              <div key={key} style={{ borderTop: i > 0 ? '1px solid #f5f5f5' : 'none' }}>
                {renderGroup(key, filterOptions.atributos[key])}
              </div>
            ))}
          </div>
        </div>

        {/* Rodapé */}
        <div style={{ padding: '14px 16px', borderTop: '1px solid #f0f0f0' }}>
          <button onClick={onClose} style={{
            width: '100%', padding: '12px', borderRadius: '8px',
            backgroundColor: '#E8773A', color: '#fff', border: 'none',
            cursor: 'pointer', fontSize: '14px', fontWeight: '700',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
            </svg>
            Filtrar ({totalCount} produtos)
          </button>
        </div>
      </div>
    </>
  );
};